import React, { memo, useRef, useState } from 'react'

import { MeasurementDevicesTableWidget } from '../../../common/features/measurement-device/measurement-devices-table-widget'
import { PageLayoutContainer } from '../../../lib/page-layout-container'
import MeasurementDeviceCreateModal from '../../components/MeasurementDeviceCreateModal'
import useText from '../../../common/hooks/useText'
import { MeasurementDeviceSearchListForm } from '../../../common/features/measurement-device/measurement-device-search-list-form'
import {
    MeasurementDevicesGetFilteredApiArg,
    useMeasurementDevicesGetFilteredQuery,
} from '../../../common/redux/api/web-api'
import { notifyError } from '../../../common/features/notificationsManager/Notify'

const defaultFiltersValue: MeasurementDevicesGetFilteredApiArg = {
    serialNumber: '',
    companyId: '',
    limit: 100,
    name: '',
    companyName: '',
    partnerName: '',
    productId: undefined,
    status: undefined,
}

export type MeasurementDevicesPageProps = {
    style?: React.CSSProperties
}

export const MeasurementDevicesPage = memo(function MeasurementDevicesPage({
    style,
}: MeasurementDevicesPageProps): React.ReactElement {
    const text = useText()
    const [openCreateModal, setOpenCreateModal] = useState(false)
    const [filter, setFilter] = useState<MeasurementDevicesGetFilteredApiArg>(defaultFiltersValue)

    const [currentPage, setCurrentPage] = useState(0)
    const filtersContainerRef = useRef<HTMLDivElement | null>(null)

    const handlePageClick = (selected: number) => {
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0)
        setCurrentPage(selected)
    }

    const pageClick = () => {
        setCurrentPage(0)
    }

    const openModal = () => setOpenCreateModal(true)

    const { currentData: deviceData, isFetching: deviceFetching } = useMeasurementDevicesGetFilteredQuery(filter)

    const handleFilterSubmit = (filters: MeasurementDevicesGetFilteredApiArg) => {
        setFilter({
            ...filters,
            limit: defaultFiltersValue.limit,
        })
        pageClick()
    }

    const clearDevices = () => {
        setFilter(defaultFiltersValue)
    }

    return (
        <PageLayoutContainer style={style}>
            <MeasurementDeviceSearchListForm
                onSubmit={handleFilterSubmit}
                clearDevice={clearDevices}
                loading={deviceFetching}
            />
            <MeasurementDevicesTableWidget
                data={deviceData || []}
                loading={deviceFetching}
                createDevice={openModal}
                currentPage={currentPage}
                handlePageClick={handlePageClick}
                pageClick={pageClick}
            />

            {openCreateModal && (
                <MeasurementDeviceCreateModal
                    errorText={() => notifyError(text('msgMeasurementDeviceError'))}
                    close={(result) => {
                        if (result) {
                            setOpenCreateModal(false)
                        }
                    }}
                    dismiss={() => setOpenCreateModal(false)}
                />
            )}
        </PageLayoutContainer>
    )
})
